<div
    class="custom-status-pill"
    [class.red-status]="statusColor === statusPillColors.RED"
    [class.green-status]="statusColor === statusPillColors.GREEN"
    [class.yellow-status]="statusColor === statusPillColors.YELLOW"
    [class.orange-status]="statusColor === statusPillColors.ORANGE"
    [class.pink-status]="statusColor === statusPillColors.PINK"
    [class.dark-gray-status]="statusColor === statusPillColors.DARK_GRAY"
    [class.light-gray-status]="statusColor === statusPillColors.LIGHT_GRAY"
    [class.blue-status]="statusColor === statusPillColors.BLUE"
    [class.purple-status]="statusColor === statusPillColors.PURPLE"
    [class.small-status]="size === 'small'"
    [pTooltip]="showStatusTooltip && statusTooltip ? (statusTooltip | translate) : null"
    [showDelay]="1000">
    {{ statusName ? (statusName | translate) : statusName }}
    @if (statusPillInfo) {
        <app-info-tooltip
            class="info-icon"
            [id]="'custom-status-info'"
            [iconClass]="'fa-sharp fa-solid fa-circle-info'"
            [tooltipText]="statusPillInfo"
            (mouseenter)="showStatusTooltip = false"
            (mouseleave)="showStatusTooltip = true"></app-info-tooltip>
    }
</div>
